export default __webpack_public_path__ + "static/media/Flag_of_Ukraine.5d68a88e.svg";